import { useState } from "react";
import { tv } from "tailwind-variants";

import type { InputProps } from "@/ui";
import { Button, icons, Input } from "@/ui";

const passwordInputVariants = tv({
  slots: {
    input: "h-15 rounded-[10px] p-3 text-lg",
    icon: "size-4",
  },
  variants: {
    error: {
      true: {
        icon: "text-danger/70",
      },
    },
  },
});

const { icon, input } = passwordInputVariants();

type PasswordInputProps = {
  showDisplayPasswordButton?: boolean;
} & InputProps;

export const PasswordInput = ({
  className,
  showDisplayPasswordButton,
  ...props
}: PasswordInputProps) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const Icon = passwordVisible ? icons.EyeIcon : icons.EyeSlashIcon;

  return (
    <Input
      className={input({ className })}
      right={
        showDisplayPasswordButton ? (
          <Button
            onClick={() => {
              return setPasswordVisible((v) => {
                return !v;
              });
            }}
            size="tight"
            variant="focus"
          >
            <Icon className={icon({ error: Boolean(props.error) })} />
          </Button>
        ) : null
      }
      type={passwordVisible ? "text" : "password"}
      {...props}
    />
  );
};
